'use es6';

import { fromJS, List } from 'immutable';
import forEach from 'transmute/forEach';
import { EMAIL_METADATA, EMAIL_PREVIOUS_REPLIES, FILES, QUICK_REPLIES, QUICK_LINKS, INLINE_IMAGES, CALL_METADATA, MESSAGE_POSITION_DESCRIPTOR, LOCATION, CONTACT, UNSUPPORTED_CONTENT, MESSAGE_HEADER, CITATION, MESSAGE_FEEDBACK_REQUEST, INTERACTIVE_CARD } from '../constants/attachmentTypes';
import EmailMetadata from '../records/EmailMetadata';
import EmailPreviousReplies from '../records/EmailPreviousReplies';
import FileAttachment from '../records/FileAttachment';
import QuickReplyAttachment from '../records/QuickReplyAttachment';
import InlineImageStatusAttachments from '../records/InlineImageStatusAttachments';
import CallMetadata from '../records/CallMetadata';
import LocationMetadata from '../records/LocationMetadata';
import ContactMetadata from '../records/ContactMetadata';
import MessagePositionDescriptor from '../records/MessagePositionDescriptor';
import UnsupportedContent from '../records/UnsupportedContent';
import MessageHeaderAttachment from '../records/MessageHeaderAttachment';
import MessageFeedbackRequestAttachment from '../records/MessageFeedbackRequestAttachment';
import InteractiveCardAttachment from '../records/InteractiveCardAttachment';
export const buildAttachments = (attachments, acceptedTypes) => {
  return List().withMutations(mutableList => {
    forEach(attachment => {
      const attachmentType = !acceptedTypes || acceptedTypes[attachment['@type']] ? attachment['@type'] : null;
      switch (attachmentType) {
        case EMAIL_METADATA:
          mutableList.push(EmailMetadata(fromJS(attachment)));
          break;
        case EMAIL_PREVIOUS_REPLIES:
          mutableList.push(EmailPreviousReplies(fromJS(attachment)));
          break;
        case CITATION:
          mutableList.push(fromJS(attachment));
          break;
        case FILES:
          mutableList.push(FileAttachment(fromJS(attachment)));
          break;
        case QUICK_REPLIES:
          mutableList.push(new QuickReplyAttachment(attachment));
          break;
        case QUICK_LINKS:
          mutableList.push(fromJS(attachment));
          break;
        case INLINE_IMAGES:
          mutableList.push(InlineImageStatusAttachments(fromJS(attachment)));
          break;
        case CALL_METADATA:
          mutableList.push(new CallMetadata(attachment));
          break;
        case LOCATION:
          mutableList.push(new LocationMetadata(attachment));
          break;
        case CONTACT:
          mutableList.push(new ContactMetadata(attachment));
          break;
        case MESSAGE_POSITION_DESCRIPTOR:
          mutableList.push(MessagePositionDescriptor(fromJS(attachment)));
          break;
        case UNSUPPORTED_CONTENT:
          mutableList.push(new UnsupportedContent(attachment));
          break;
        case MESSAGE_HEADER:
          mutableList.push(new MessageHeaderAttachment(attachment));
          break;
        case MESSAGE_FEEDBACK_REQUEST:
          mutableList.push(new MessageFeedbackRequestAttachment(attachment));
          break;
        case INTERACTIVE_CARD:
          mutableList.push(new InteractiveCardAttachment(attachment));
          break;
        default:
          break;
      }
    }, attachments || List());
  });
};